import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AuthState } from './types';
import { RootState } from '../../types';
import { EmbeddedData } from '../../embedded-data';
import { nodeSaml } from './node_saml/index';

const isAuthModuleEmbeddedError = EmbeddedData.authErrorStatus >= 400 && EmbeddedData.authErrorStatus < 500;

export const state: AuthState = {
    notice: undefined,
    processing: false,
    error: false,
    errorCode: undefined,
    errorMsg: undefined,
    isUpdated: false,
    embedded: {
        notice: EmbeddedData.authNotice,
        error: isAuthModuleEmbeddedError,
        errorCode: isAuthModuleEmbeddedError ? EmbeddedData.authErrorCode : undefined,
        errorMsg: isAuthModuleEmbeddedError ? EmbeddedData.authErrorMsg : undefined,
    },
    myAuthorities: {
        list: undefined,
        isProcessing: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    softRegistered: {
        secret_key: undefined,
        isProcessing: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    sendMail: {
        isProcessing: false,
    },
    updateForgottenPassword: {
        isProcessing: false,
    },
};

const namespaced: boolean = true;

export const auth: Module<AuthState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
    modules: {
        nodeSaml,
    },
};
